import React from 'react'
import { Box, Button, Typography, Container } from "@mui/material";
import { useNavigate } from 'react-router-dom';



const Angebot = () => {

    const navigate = useNavigate();
    const handlenext =  () => {
        navigate("/angebotanforden");
    }
  return (
    <Box sx={{ backgroundColor: "#f4f6fb", py: 8 }}>
    <Container maxWidth="lg">
      <Box
        sx={{
          backgroundColor: "#70C9C0",
          borderRadius: 4,
          px: { xs: 4, md: 8 },
          py: { xs: 6, md: 8 },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Text */}
        <Typography
          variant="h5"
          component="div"
          sx={{
            fontWeight: "bold",
            color: "white",
            textAlign: { xs: "center", md: "left" },
            mb: { xs: 3, md: 0 },
          }}
        >
          Kontaktieren Sie uns für weitere Informationen
        </Typography>

        {/* Button */}
        <Button
          variant="contained"
          onClick={handlenext}
          sx={{
            backgroundColor: "#f4f6fb",
            color: "#292B78",
            fontWeight: "bold",
            fontSize: "0.875rem",
            px: 4,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 3,
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#f0f0f0",
            },
          }}
          endIcon={<span>→</span>}
        >
          ANGEBOT ANFORDERN
        </Button>
      </Box>
    </Container>
  </Box>
  )
}

export default Angebot
